import { cleanAttributionDisplay, joinWords } from "./string";
import _ from "./lodash";
var getAttributionDisplay = function (_a) {
    var name = _a.name, organization = _a.organization;
    return (name && organization && name + " " + organization) || name || organization || "";
};
export var formatAttributions = function (attributions) {
    if (attributions === void 0) { attributions = []; }
    return joinWords.apply(void 0, _.orderBy(attributions, 
    // Move attributions with names to the front, so that they'll all be displayed prior to any organizations.
    [function (_a) {
            var name = _a.name;
            return !!name;
        }], ["desc"]).map(function (singleAttribution) {
        // swap out attribution objects with their display values
        return cleanAttributionDisplay(getAttributionDisplay(singleAttribution));
    }).filter(function (attributionDisplayValue) {
        // filter out any empty attribution display values
        return !!attributionDisplayValue;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/image.ts
// module id = txaO
// module chunks = 2